import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class RectangleBox extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    header: PropTypes.node,
    subheader: PropTypes.node,
    value: PropTypes.node,
    subvalue: PropTypes.node,
  };

  render() {
    const { className, header, subheader, value, subvalue } = this.props;
    return (
      <div className={classnames('rectangle-box', className)}>
        <div className="rectangle-box__left-grid">
          <div className="rectangle-box__header">{header}</div>
          <div className="rectangle-box__subheader">{subheader}</div>
        </div>
        <div className="rectangle-box__right-grid">
          <div className="rectangle-box__value">{value}</div>
          <div className="rectangle-box__subvalue">{subvalue}</div>
        </div>
      </div>
    );
  }
}

export default RectangleBox;
